// TODO revise
import React from "react";
import * as Yup from "yup";

import i18n from "../../../../../../i18n";
import { Field, FormConfig } from "../../../../../controls/FormikForm";
import Tag from "../../../../../inputs/Tag";
import AnswerInput from "../../inputs/AnswerInput";
import Button from "../../../../../Button";

import { leaveInterceptor } from "./selectors";

import styled from "styled-components/macro";

const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
`;

const validationSchema = Yup.object().shape({
  answer: Yup.string().required(i18n.t("form:emptyFieldValidation"))
});

const AnswerForm = ({
  t,
  onSubmit,
  onClose,
  initialValues,
  admitTags,
  tags = [],
  canEditAnswer,
  answerType
}) => {
  function handleSubmit(values) {
    onSubmit(leaveInterceptor(values));

    onClose();
  }

  return (
    <FormConfig
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      initialValues={initialValues}
    >
      {({ isValid, handleSubmit }) => (
        <form
          data-test="answerForm"
          onSubmit={event => {
            event.stopPropagation();

            handleSubmit(event);
          }}
        >
          <div>
            <Field
              disabled={!canEditAnswer}
              name="answer"
              label={t("opportunity:process.stepTypes.chatbot.tree.answer")}
              help={
                canEditAnswer &&
                t(
                  "opportunity:process.stepTypes.chatbot.tree.answerSupportedChars"
                )
              }
            >
              <AnswerInput autoFocus t={t} answerType={answerType} />
            </Field>
          </div>
          {admitTags && (
            <div>
              <Field
                name="tag"
                label={t("opportunity:process.stepTypes.chatbot.tree.tag")}
              >
                <Tag style={{ alignSelf: "flex-start" }} tags={tags} />
              </Field>
            </div>
          )}
          <Footer>
            <Button
              style={{ marginRight: 12 }}
              htmlType="button"
              type="quaternary"
              onClick={onClose}
            >
              {t("global:cancel")}
            </Button>
            <Button htmlType="submit" type="primary" disabled={!isValid}>
              {t("global:save")}
            </Button>
          </Footer>
        </form>
      )}
    </FormConfig>
  );
};

export default AnswerForm;
